export default {
  s: '2px',
  m: '4px',
  pill: '17px',
  round: '50%',
};
